<template>
  <div
    class="card-item"
    style="width:50%;height: 100%;display: inline-block;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <!-- <div class="device-picker" style="right: auto;left: 20px;top: 12px;">
      电子性诱
    </div> -->
    <div class="last-data">
      <div class="data-list-container" cellpadding="0" v-if="reload">
        <table border="0" cellspacing="0">
          <thead>
            <tr>
              <th style="width: 140px;">
                <div class="cell">名称</div>
              </th>
              <th>
                <div class="cell text-center">今日</div>
              </th>
              <th>
                <div class="cell text-center">
                  昨日
                </div>
              </th>
              <th>
                <div class="cell text-center">
                  30日
                </div>
              </th>
            </tr>
          </thead>

          <tbody ref="scroller">
            <tr v-for="(item, idx) in analysis" :key="item.id">
              <td style="width:140px;" :style="{ color: getColor(idx) }">
                <div class="cell">{{ item.name }}</div>
              </td>
              <td>
                <div class="cell text-center">
                  {{ item.todayCount }}
                </div>
              </td>
              <td>
                <div class="cell text-center">
                  {{ item.count }}
                </div>
              </td>
              <td>
                <div class="cell text-center">
                  {{ item.sum }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <echart
        v-if="reload"
        chartId="home-trap"
        :options="options"
        :height="height - 132"
      ></echart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import sleep from '@/utlis/sleep'
import { getStatistic, getPreview } from '@/service/trap'
import Echart from '@/components/Chart'
import mixin from '../mixin'

export default {
  components: { Echart },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      loadingStatic: false,
      loadingPreview: false,
      reload: false,
      analysis: [],
      summary: [],
      begin: moment()
        .subtract(30, 'days')
        .format('YYYY-MM-DD'),
      // .startOf('month')
      end: moment().format('YYYY-MM-DD'),
      colors: ['#8190ff', '#ff9b87']
    }
  },
  computed: {
    xAxis() {
      const { begin, end } = this
      const bm = moment(begin)
      const em = moment(end)
      let xAxis = [bm.format('YYYY-MM-DD')]
      let current = moment(begin)

      while (current.isBefore(em)) {
        current = current.add(1, 'd')
        xAxis.push(current.format('YYYY-MM-DD'))
      }
      return xAxis
    },
    options() {
      let { summary, analysis, xAxis, colors } = this
      return {
        legend: { show: false },
        xAxis: [{ type: 'category', data: this.xAxis }],
        yAxis: { gridIndex: 0, splitLine: { show: false } },
        tooltip: { trigger: 'axis' },
        position: function(pos, params, el, elRect, size) {
          var obj = { top: -40 }
          obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30
          return obj
        },
        grid: {
          top: 4,
          bottom: 4
        },
        series: analysis.map((d, idx) => {
          const data = summary.filter(o => o.deviceId === d.id)
          return {
            name: d.name,
            type: 'bar',
            color: colors[idx],
            data: xAxis.map(x => {
              const cells = data.filter(l => l.date === x)
              return cells.reduce((total, cur) => (total += cur.count), 0)
            })
          }
        })
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await Promise.all([this.getData(), this.getPreview(this.begin, this.end)])
      this.loading = false
    },
    async getData() {
      this.loadingStatic = true
      const [{ data }] = await Promise.all([
        getStatistic(this.companyId),
        sleep(1)
      ])
      this.loadingStatic = false
      this.analysis = data
    },
    async getPreview(begin, end) {
      this.loadingPreview = true
      const [{ data }] = await Promise.all([
        getPreview({
          companyId: this.companyId,
          begin,
          end
        }),
        sleep(1)
      ])
      this.loadingPreview = false
      this.summary = data
    },
    getColor(idx) {
      return this.colors[idx]
    }
  },
  watch: {
    // 监控高度刷新 el-table 高度
    height() {
      this.reload = false
      this.$nextTick(() => {
        this.reload = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-picker {
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  padding-left: 20px;
  padding-top: 8px;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.no-data {
  height: 100%;
}
.data-list-container {
  height: 120px;
}
table {
  padding: 0 12px;
  width: 100%;
  text-align: left;
  thead {
    background-color: rgba(20, 53, 114, 0.5);
    border: none;
  }
  th,
  td {
    padding: 8px 0;
    box-sizing: border-box;
  }
  tbody {
    display: block;
    overflow-y: hidden;
  }

  tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }
  tbody tr:nth-child(even) td,
  tbody tr:nth-child(even) td {
    background-color: rgba(20, 53, 114, 0.5);
  }

  .cell {
    padding: 0 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }
  .cell.text-center {
    text-align: center;
  }
}
</style>
